export default "<span #text><ng-content></ng-content></span>";